import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { feedCategories } from '../../data/mockData';

const FeedCategories = () => {
  return (
    <section className="py-24 bg-[#FEFCF8]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-3 py-1 rounded-full bg-[#2D5016]/10 text-[#2D5016] text-xs font-semibold uppercase tracking-wider mb-4">
            What We Offer
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#3B2F1E] mb-4">
            Our Feed Categories
          </h2>
          <p className="text-[#3B2F1E]/70 text-lg max-w-2xl mx-auto">
            We offer a wide range of feed to meet the needs of small farms, homesteads, and larger operations
          </p>
        </div>

        {/* Categories Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {feedCategories.map((category, index) => (
            <Link
              key={category.id}
              to="/shop"
              className="group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              {/* Image Container */}
              <div className="relative h-64 overflow-hidden">
                <img
                  src={category.image}
                  alt={category.name}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
                {/* Overlay */}
                <div className="absolute inset-0 bg-gradient-to-t from-[#3B2F1E]/80 via-[#3B2F1E]/20 to-transparent" />
                
                {/* Content Overlay */}
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="font-serif text-xl font-bold text-white mb-2">
                    {category.name}
                  </h3>
                  <p className="text-white/80 text-sm">
                    {category.description}
                  </p>
                </div>
              </div>

              {/* Browse Link */}
              <div className="absolute inset-0 bg-[#2D5016]/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-500">
                <span className="flex items-center gap-2 text-white font-semibold text-lg">
                  Browse
                  <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeedCategories;
